const data: Cinch.WebAppTranslations = {
  aboutUs: {
    title: 'About Us',
    description:
      'Hi, we’re cinch. A faff-free car service whose sole purpose is to help you buy, sell, or part exchange your car in an easy and simple way.',
    hero: {
      heading: 'Hi, we’re cinch.',
      subHeading: `We’re the faff-free car service backed by BCA, one of Britain’s biggest automotive service companies. And we’re the only place you need to go to buy, sell or part-exchange your car.`,
    },
    ourVision: {
      title: 'Our mission',
      description: `It’s simple – to take out all the irritations and hold-ups that make changing cars trickier than it needs to be.

We know what drivers want. And we’ve ripped up the rule book to make sure you get it. `,
    },
    workWithUs: {
      heading: 'Jobs at cinch',
      subHeading:
        'We’ve managed to attract some of the smartest folk. But we’re always on the lookout for more. If you’re interested in joining us, get in touch. We’d love to hear from you.',
      rolesCTA: 'View our roles',
      roleDetails: {
        title: 'Role title',
        description: 'Short description leo, laoreet ac rhon cus in, eges tas rhoncus sa pien. Nunc eget.',
        ctaText: 'See full description',
      },
      linkToCandidatePrivacy: '* See our candidate privacy policy',
    },
    contactPanel: {
      title: 'Get in contact',
      email: 'hello@cinch.co.uk',
      caption: `cinch is provided by:
Cinch Cars Limited
of
Headway House
Crosby Way
Farnham GU9 7XG, UK

Registered in England and Wales with company number 11520330 and VAT registration number 312240070`,
    },
  },
  accountConfirm: {
    pendingTitle: 'Confirming Registration',
    successTitle: 'Successfully registered',
    successText: '',
    genericErrorTitle: 'Error',
    genericErrorText: '',
    login: 'Log in',
  },
  allFavourites: {
    title: 'Save & compare',
    back: 'Back to Profile',
    remove: 'Remove all unavailable cars',
  },
  authModal: {
    title: 'Register or log in',
    shortlist: 'Shortlist favourite cars',
    recommendations: 'Save recommendations',
    compare: 'Compare vehicles',
    features: 'Many other features!',
  },
  banner: {
    title: 'Buy a car. Get free fuel.',
    subTitle: 'The first 300 people to buy a car using cinch will get a free fuel card worth £200.',
  },
  comingSoon: {
    heading: 'A new way to find the right car for you',
    title: 'Stay Updated With Us',
    description:
      'We have a new exciting feature coming soon to you. Stay up to date with the coming release by joining us today!',
    body: 'Stay up to date with the latest release by joining us today',
    comingSoon: {
      buttonSubmitText: 'Stay in touch',
      email: {
        label: 'Email address',
        placeholder: 'email@example.com',
      },
    },
  },
  compare: {
    title: 'Comparing your choices',
    differences: 'Differences are highlighted',
    filter: 'Filter categories',
    clearFilters: 'Clear filters',
    unavailable: 'Car unavailable',
    back: 'Back',
    price: 'Price',
    age: 'Age',
    body: 'Body',
    mileage: 'Mileage',
    engine: 'Engine',
    fuelType: 'Fuel',
    doors: 'Doors',
    economy: 'Fuel Economy',
    co2: 'CO2 Emissions (g/km)',
    emission: 'Emission standard (Euro)',
    topSpeed: 'Top Speed',
    acceleration: 'Acceleration (0-60)',
    serviceIntervalMiles: 'Service interval (miles)',
    serviceIntervalTime: 'Service interval (months)',
    ncap: 'NCAP Rating',
    maxRoofLoad: 'Max Roof Load (kg)',
    towingWeightBraked: 'Towing weight - Braked (kg)',
    towingWeightUnbraked: 'Towing weight - Unbraked (kg)',
    luggageCapacitySeatsUp: 'Luggage Capacity - seats up (ltr)',
    luggageCapacitySeatsDown: 'Luggage Capacity - seats down (ltr)',
    height: 'Height (mm)',
    width: 'Length (mm)',
    length: 'Width (mm)',
  },
  delivery: {
    title: 'cinch Delivery',
  },
  errorPage: {
    title: '404 - Wrong turn!',
    subTitle: 'Don’t worry, we can put you back on track!',
    ctaText: 'Take me home',
  },
  findVehicle: {
    title: 'Find it',
    description:
      'Compare thousands of cars and find the one that’s right for you. Whether its by model, brand or vehicle type, cinch makes it simple and faff free.',
    search: {
      search: 'Search',
      placeholder: 'Search by model, brand or vehicle type',
    },
    saveSearch: {
      button: 'Save this search',
      untitledName: 'My saved search',
    },
    filters: {
      title: 'Filter vehicles',
      settings: 'Settings',
      filters: 'Filters',
      clear: 'Clear all',
      location: 'Location',
      money: {
        title: 'Money',
        cash: 'Budget',
        submit: 'Save',
        total: 'Total',
        partEx: 'Part exchange',
        finance: 'Finance',
      },
      within: 'Within',
      of: 'of',
    },
    fuelFinder: {
      topline: 'Want to save £100s on fuel?',
      strapline: 'Find the cheapest fuel prices wherever, whenever for FREE.',
      smallPrint: 'Average potential savings over cross section of destinations',
      tagline: 'cinch Fuel Saver coming soon',
      firstBulletPoint: 'Up to date prices',
      secondBulletPoint: 'Major fuel brands',
      cta: { saveNow: 'Save now' },
      fuelSaver: 'fuel saver',
    },
    noResults: {
      withDelivery:
        'No cars found with your search. Try searching for cars that aren’t available for cinch Delivery, or try something else,',
      withoutDelivery: 'No cars found with your search. Try searching for cinch Delivery cars, or try something else,',
    },
    deliveryPreference: {
      title: 'Delivered cars',
      moreInfo: 'More info',
      bullet1: '7-day money back guarantee',
      bullet2: 'Thorough 150+ point inspection',
      onLabel: 'on',
      offLabel: 'off',
    },
    deliveryModal: {
      bullet1: 'Buy online. Free home delivery',
      bullet2: '7-day money back guarantee',
      bullet3: 'Thorough 150+ point inspection',
      bullet4: '90-day warranty',
      bullet5: 'Buy, finance and part exchange entirely online',
      bullet6: 'No hidden or extra admin fees',
    },
  },
  footer: {
    terms: 'Terms',
    privacy: 'Privacy',
    about: 'About',
    partner: 'Partners',
  },
  forgotPassword: {
    title: 'Forgot Password',
    forgotPassword: {
      heading: 'Enter your email address and we’ll send you a secure link to reset your password.',
      buttonSubmitText: 'Reset password',
      email: {
        label: 'Email address',
        placeholder: 'email@example.com',
      },
    },
    forgotPasswordSuccess: {
      heading: 'Check your inbox!',
      paragraphOne: "We've sent a email to",
      paragraphTwo: `The link will be valid for the next 24 hours
If you don't receive the email, please check in your spam folder`,
    },
  },
  forgotPasswordConfirm: {
    title: 'Reset Password',
    form: {
      buttonSubmit: 'Reset Password',
      newPassword: 'Enter new password',
      confirmPassword: 'Confirm new password',
      success: {
        heading: 'Success!',
        paragraphOne: 'Your password has been changed.',
        paragraphTwo: `Please log in with your new details`,
        paragraphThree: '',
      },
    },
  },
  home: {
    seo: {
      title: 'Cars Without The Faff',
      description:
        'Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, all under 7 years old & under 70,000 miles ready to be sold to you.',
    },
    heading: 'Welcome to cars <br>without the faff.',
    subheading: 'Find it. Buy it. Sell it.',
    body: 'Thousands of used cars. All under 7 years old. All under 70,000 miles.',
    bodySub: 'We’re cinch, the faff-free service that makes finding, buying and selling a used car - easy.',
    filterHeading: 'Find a car for delivery',
    getStartedCtaSelectCar: 'I know what I want',
    getStartedCtaNotSure: 'Help me choose',
    ourCommitmentTitle: 'The cinch commitment',
    ourCommitmentTitleMobile: 'The cinch commitment',
    ourCommitmentButton: 'Tell me more',
    helpMeChooseTitle: 'Help me choose',
    helpMeChooseBody:
      'Not sure what you’re looking for? Or just looking around? Answer a few quick questions with our matchmaker tool and we’ll sift through thousands of vetted cars to find The One for you.',
    helpMeChooseButton: 'Find my match',
    findYourCar: 'Find your car',
    heroImageAlt: 'hand holding car keys',
    bannerTitle: 'COVID-19',
    bannerSubTitle:
      'The situation around COVID-19 is changing every day. Keep safe by reading the most up-to-date information about what we and our dealers are doing.',
    articles: {
      title: 'Articles',
      cta: 'All articles',
    },
    reviews: {
      title: 'Reviews',
      cta: 'All reviews',
    },
  },
  findYourCar: {
    allCars: 'All cars',
  },
  guides: {
    title: 'How-to Guides',
    searchPlaceholder: 'Search how-to guides',
    noResultsBody: 'No guides found with your search, please try something else',
  },
  jargon: {
    title: 'Jargon Buster',
    resultsTitle: 'Search Results',
    recent: 'Recent',
    noResultsTitle: "Sorry, we haven't found any articles that match, try a different word or phrase",
  },
  lifestyle: {
    title: 'Find the Best Car For You',
    description:
      'Answer a few questions about your budget and lifestyle and we will be able to match you with your ideal car. cinch does the hard work for you.',
    intro: {
      intro: `Let’s find the right car for you`,
      body: `Answer the following questions and our handy matchmaker tool will recommend the best cars for your budget and lifestyle, faster than you can parallel park.`,
      cta: "Let's do this",
    },
    required: 'Budget is a required value',
    budget: {
      title: `What's your budget?`,
      intro:
        'Answer the following questions and our handy matchmaker tool will recommend the best cars for your budget and lifestyle, faster than you can parallel park.',
      budgetLabel: 'My budget',
      cash: `What's your budget?`,
      partEx: 'Exchange your current car as part of the deal?',
      finance: 'Do you plan to borrow any money to buy the car?',
      total: 'Total',
    },
    passengers: {
      title: `Who's on board?`,
      add: 'Add passenger',
      remove: 'Remove last passenger',
      type: {
        label: 'Family member',
        dog: 'Dog',
        adult: 'Adult',
        child: 'Child',
      },
      sizeOfDog: 'Dog Size',
      ageOfHuman: 'Age',
      heightOfHuman: 'Height',
    },
    roads: {
      title: 'Where do you drive?',
      motorway: 'Motorways and A roads',
      city: 'City Streets',
      country: 'Winding country lanes',
    },
    distance: {
      title: 'How far do you drive?',
      distanceShort: 'Short trips (<20 miles)',
      distanceMedium: 'Medium journeys (20-50 miles)',
      distanceLong: 'Long distances (50+ miles)',
    },
    frequency: {
      title: 'How often do you drive?',
      drivingFrequency: 'How often do you drive?',
    },
    importanceAbstract: {
      title: 'Tap the pictures you like',
    },
    textual: {
      title: 'What are your must-haves?',
    },
    actions: {
      next: 'Next',
      back: 'Back',
      results: 'Skip to recommendations',
      privacyNotice:
        'Your data will be saved, see <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Notice</a>',
    },
  },
  maintenance: {
    heading: `We're down for maintenance for a bit.`,
    subHeading: 'Please check again soon.',
  },
  manufacturer: {
    findMore: 'Show more {placeholder} cars for sale',
    introduction: 'Used {placeholder} cars for sale',
    forSale: 'Used {placeholder} cars for sale',
    unavailable: 'Sorry, there are no {placeholder} vehicles available at the moment.',
    related: 'Related',
    jargon: 'Jargon Buster',
    models: 'Models',
    seeOther: 'See other makes',
    viewArticles: 'View all articles',
    viewJargon: 'View all jargon',
  },
  carsPage: {
    title: 'Nearly New and Used Cars for Sale',
    description:
      'Looking for a used car? Cinch has a full range of nearly new cars for sale near you. All under 7 years old & less than 70,000 miles.',
    heading: 'Browse Makes',
  },
  myProfile: {
    title: 'Profile',
    sectionTitles: {
      profile: 'Your profile',
      settings: 'Settings',
    },
    location: {
      title: 'Location',
      subtitle: 'Make it easier to find cars near me.',
    },
    edit: {
      title: 'Personal details',
      personalDetailsTitle: 'Edit Personal Details',
      body: 'People on cinch will get to know you with the info below',
      firstName: {
        label: 'First Name',
        placeholder: 'First name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Last name',
      },
      phoneNumber: {
        label: 'Mobile Number',
        placeholder: 'Mobile Number',
      },
      preferenceSms: {
        label: 'SMS',
        description: 'OK, you can send me text messages.',
      },
      preferenceEmail: {
        label: 'Email',
        description: 'OK, you can send me emails.',
      },
      preferenceDigital: {
        label: 'No communication',
        description: `No, I don't want to receive optional messages from cinch (we'll still need to send service related messages such as password reminders, answers to enquiries or messages about your account).`,
      },
      marketingPreference: 'Communication preferences',
      marketingBody: `As part of the service, from time to time we'll  send you information relating to vehicles or searches you've saved (e.g. changes in price, no longer on sale. alternatives on site), or information relevant to your stage of the purchase process. Please indicate how you'd like to receive these`,
      cancelLabel: 'Cancel',
      submitLabel: 'Save',
      privacyNotice:
        'Your data is processed securely, legally and fairly as explained in our <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Notice and Cookie Policy here</a>',
    },
    account: {
      changePassword: {
        title: 'Change password',
        successMessage: 'Password updated successfully',
        buttonSubmitText: 'Update Password',
        currentPassword: {
          label: 'Current password',
          placeholder: 'Current password',
        },
        newPassword: {
          label: 'New password',
          placeholder: 'New password',
        },
        confirmPassword: {
          label: 'Confirm password',
          placeholder: 'Confirm password',
        },
      },
      downloadAccountData: {
        title: 'Download my data',
        body: 'Your data will be downloaded in a CSV file',
        buttonSubmitText: 'Download',
      },
      delete: {
        title: 'Delete account',
        warningMessage: 'Please note, this cannot be reversed, your data will be deleted',
        buttonSubmitText: 'Delete account',
        password: {
          label: 'Enter password',
          placeholder: 'Enter password',
        },
      },
    },
    money: {
      title: 'Your money',
      subtitle: 'This will help us give you search results that suit what you want to spend.',
      budgetLabel: 'My Budget',
      cash: "What's your budget?",
      partEx: 'Exchange your current car as part of the deal?',
      finance: 'Do you plan to borrow any money to buy the car?',
      submit: 'Update',
    },
    anonProfile: {
      info: {
        title: 'Complete your profile now',
      },
      features: {
        shortlist: 'Shortlist favourite cars',
        recommendations: 'Save recommendations',
        compare: 'Compare vehicles',
        manymore: 'Many other features!',
      },
    },
    favouriteVehicles: {
      title: 'Cars I’m interested in',
      emptyTitle: 'No saved cars to compare',
      body: 'To save some searches as your favourites, please click',
      link: 'here',
      emptySavedCarTitle: 'Saved cars',
      savedCarTitle: 'Your saved car',
      savedCarTitlePlural: 'Your {favouriteVehicleCount} saved cars',
      anonProfile: {
        title: 'Save cars to view or compare later',
        body: 'Login or register to save and compare your favourite cars and view the list of your saved cars here.',
      },
      carousel: {
        title: 'Save & Compare',
        cta: 'View all',
      },
    },
    deliveryPreference: {
      title: 'Delivered cars',
      moreInfo: 'More info',
      bullet1: '7-day money back guarantee',
      bullet2: 'Thorough 150+ point inspection',
      onLabel: 'on',
      offLabel: 'off',
    },
    deliveryModal: {
      bullet1: 'Buy online. Free home delivery',
      bullet2: '7-day money back guarantee',
      bullet3: 'Thorough 150+ point inspection',
      bullet4: '90-day warranty',
      bullet5: 'Buy, finance and part exchange entirely online',
      bullet6: 'No hidden or extra admin fees',
    },
    savedSearches: {
      title: 'Saved searches',
      emptySearch: {
        body1: 'You currently have no Saved Searches. Go to the',
        body2: 'to start searching for vehicles.',
        link: 'listings page',
      },
      anonymous: {
        body: 'Login or register to save a favourite vehicle search and view the list of your saved search here.',
      },
    },
  },
  navigation: {
    buy: 'Find it',
    help: 'Help me choose',
    sell: 'Sell it',
    jargon: 'Jargon Buster',
    guides: 'How-to Guides',
    partners: {
      overview: 'Overview',
      dealerships: 'Dealerships',
    },
  },
  ourCommitmentModule: {
    title: 'The cinch commitment',
    buttonCta: 'What is the cinch commitment?',
    bullet1: 'All cars under 7 years',
    bullet2: 'All under 70,000 miles',
    bullet3: 'Over 100,000 vetted cars',
    bullet4: 'More than 1,000 approved dealers',
  },
  ourCommitmentPage: {
    title: 'The cinch commitment',
    register: 'Register',
    find: 'Help me choose',
  },
  deliveryModule: {
    title: 'home delivery',
    bullet1: 'Buy online. Free home delivery',
    bullet2: '7-day money back guarantee',
    bullet3: 'Thorough 150+ point inspection',
    bullet4: '90-day warranty',
    bullet5: 'Buy, finance and part exchange entirely online',
    bullet6: 'No hidden or extra admin fees',
    buyNow: 'Find out more',
  },
  partners: {
    landing: {
      seo: {
        title: 'Dealer Dashboard',
        description:
          'Discover one of the many amazing benefits of using cinch and see the value we’re adding to your business in a straight forward and easy to read way.',
      },
      headerTitle: 'DEALER DASHBOARD',
      heading: 'Dealer Dashboard',
      subheading: 'Shows the value cinch is adding to your business.',
      performanceTitle: 'View performance',
      performanceText: 'View the online performance of all your dealerships under one roof',
      trafficTitle: 'Check traffic',
      trafficText: 'Check your online traffic of your vehicles on cinch',
      cinchLink: 'Go to cinch consumer website',
      logoutButtonText: 'Log out',
      loginButtonText: 'Login to dashboard',
      loginButtonTextShort: 'Login',
    },
    dashboard: {
      noDealersDashboard: {
        noDealersDashboardTitle: 'Dealer dashboard',
        noDealersDashboardText:
          'It appears you have no cinch data to view. Please head back to the consumer website, or if you feel this is incorrect please let us know at <a href="mailto:hello@cinch.co.uk">hello@cinch.co.uk</a> and we will be in touch to sort your issue.',
      },
      pageTitle: 'Dashboard',
      title: 'Dashboard',
      dashboardTitle: 'Your Dashboard',
      searches: 'Search appearances',
      views: 'Full page ad views',
      favourites: 'Favourited vehicles',
      customerInteractions: 'Customer Interactions',
      locationViews: 'Location views',
      calls: 'Calls',
      emails: 'Emails',
      websiteReferrals: 'Website referrals',
      callBackRequests: 'Call back requests',
      download: {
        actionButtonText: 'Export to CSV',
        modalTitle: 'Export to CSV',
        modalButtonText: 'Download',
        modalText:
          "Please confirm that you wish to download data for the selected dealerships and date range. Please note that this download includes personal data, and you must process it only in accordance with cinch's General Advertising Terms and applicable laws.",
      },
    },
    dealerships: {
      pageTitle: 'Dealerships',
      title: 'Dealerships',
      name: 'Name',
      address: 'Address',
      referenceNumber: 'Reference Number',
    },
  },
  recommendations: {
    title: 'We recommend',
    subTitle: 'Based on your needs',
    listHeading: "Here's some other models which also meet your needs",
    updateAnswer: 'Update answers',
    saleCTA: 'View cars for sale',
    starMessage: 'This model scored top for your needs',
    loadingTitle: 'Ok, that’s all we need. Stand by for magic.',
    noResults: {
      title: 'Sorry, we can’t think of a match',
      subTitle:
        'We’ve racked our brains but we’re not sure a car like that exists. Give it another go with different answers and we’ll find you your match.',
      updateAnswer: 'Change my answers',
      saleCTA: 'Search cars',
    },
  },
  registration: {
    seo: {
      title: 'Register',
      description: 'Register with us at cinch, the easy, simple & faff-free way to buy or sell your car.',
    },
    title: 'Register',
    success: {
      heading: 'Check your inbox!',
      paragraphOne: `We've sent an email to `,
      paragraphTwo: `The link will be valid for 24 hours
If you don't receive the email, please check in your spam folder`,
    },
    signup: {
      firstName: {
        label: 'First Name',
        placeholder: 'First Name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Last Name',
      },
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      phoneNumber: {
        label: 'Mobile Number',
        placeholder: 'Mobile Number',
      },
      password: {
        label: 'Password',
        placeholder: 'Password',
      },
      passwordConfirm: {
        label: 'Confirm Password',
        placeholder: 'Confirm Password',
      },
      terms:
        'I agree to the <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>',
      preferenceSms: {
        label: 'SMS',
        description: 'OK, you can send me text messages.',
      },
      preferenceEmail: {
        label: 'Email',
        description: 'OK, you can send me emails.',
      },
      preferenceDigital: {
        label: 'No communication',
        description: `No, I don't want to receive optional messages from cinch (we'll still need to send service related messages such as password reminders, answers to enquiries or messages about your account).`,
      },
      marketingPreference: 'Communication preferences',
      marketingBody: `As part of the service, from time to time we'll  send you information relating to vehicles or searches you've saved (e.g. changes in price, no longer on sale. alternatives on site), or information relevant to your stage of the purchase process. Please indicate how you'd like to receive these`,
      submit: 'Register',
      privacyNotice:
        'Your data will be processed in accordance with our <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Notice</a>',
    },
  },
  search: {
    search: 'Search',
    placeholder: 'Search by model, brand or vehicle type',
    placeholderSmall: 'Search',
    speechPlaceholder: 'Speak to search',
    byVoice: 'Search by voice',
    showSearch: 'Show search',
    hideSearch: 'Hide search',
  },
  sellVehicle: {
    landing: {
      pageDescription:
        'Thinking of selling your car? Get a valuation for your car just by entering your registration plate and a few details and cinch will do the rest.',
      title: "What's my car worth? ",
      body: 'Just enter your registration plate and our friends at We Buy Any Car will handle the rest.',
      numberPlate: {
        label: 'Reg plate',
        placeholder: 'eg. KZ66 ZYT',
      },
      ctaText: 'Your faff-free valuation is <strong>60 seconds</strong> away',
      ctaLabel: 'Value my car',
      poweredBy: 'Powered by',
      error: 'This feature is currently unavailable. Please try again later.',
    },
    manualLookup: {
      submit: 'This is my car',
    },
    car: {
      panelTitle: 'Select car',
    },
    questions: {
      submit: 'Get my valuation',
      panelTitle: 'Not my car',
      carDetails: 'Car Details',
      yourDetails: 'Your Details',
    },
    valuation: {
      panelTitle: 'Your Valuation',
      panelBody: 'Completion of your vehicle sale may be subject to a transaction fee',
      paymentInfo: 'Transaction & payment information',
      transactionFee: 'Is there a transaction fee?',
      ctaText: 'Edit car details',
      getPaid: 'How quickly can I get paid?',
      pricePromise: 'Our Guarantees - 24 hours Price Promise',
      paymentTermsTitle: 'Premier Payment terms & conditions',
      paymentPanels: {
        hurry: {
          title: 'Not in a hurry?',
          body: '4 working days',
          footer: 'FREE',
        },
        nextDay: {
          title: "I'd like payment next working day",
          body: 'Next working day',
          footer: '£24.75',
        },
        premierPayment: {
          title: 'I want to get paid within 30 minutes',
          body: 'Premier Payment',
          footer: '£29.75',
        },
      },
      schedule: {
        title: 'Book to sell your car',
        selectLabel: 'Select branch and date',
        milesAway: 'miles away',
        select: 'Select',
        back: 'Back to branch & date',
        changePostcode: 'Change postcode',
        updatePostcode: 'Update',
        cancel: 'Cancel',
        dateLabel: 'Select a date',
        timeLabel: 'Select a time',
      },
      valuationActions: {
        title: "Here's your valuation, what would you like to do next?",
        sellCtaLabel: 'Book to sell your car',
        findCtaLabel: 'Find your next car',
      },
    },
  },
  support: {
    title: 'Support',
    description:
      'Hi, we’re cinch. A faff-free car service whose sole purpose is to help you buy, sell, or part exchange your car in an easy and simple way.',
    c19Heading: 'Helping you buy safely during COVID-19',
    c19Body:
      'As people are spending more time safe in their own homes, our website has been busy, with lots of customers browsing for their next car. We also understand some people may find they need a car to help them during these tricky times. We want to assure everyone that we’re closely following UK Government & Public Health guidance in response to COVID-19. Our car dealer partners are safely and surely welcoming you back to their retail locations introducing changes to protect both customers and their staff. If you have any questions about buying or selling a car safely at this time, please contact the cinch customer service team through live chat, text or WhatsApp. In the meantime, we hope you stay safe and healthy during this time.',
    contactAndFaqHeading: 'Contact and FAQ',
    emailUsHeading: 'Email us',
    emailUsBody: 'Send us a message with any question about any car:',
    emailUsEmailAddress: 'hello@cinch.co.uk',
    phoneUsHeading: 'Phone us',
    phoneUsBody: 'Want to talk to someone over the phone? Give us a call:',
    phoneUsPhoneNumber: '(0161) 203 2223',
    pressEnquiriesHeading: 'Press enquiries',
    pressEnquiriesBody: 'For media enquiries, please contact:',
    pressEnquiriesEmailAddress: 'press@cinch.co.uk',
    faqHeading: 'Browse FAQ',
    faqBody: 'Get answers to everything from how we choose our cars to how to make payments.',
    addressHeading: 'Address',
    address: {
      organisationName: 'Cinch Cars Limited',
      buildingName: 'Headway House',
      thoroughfare: 'Crosby Way',
      postTown: 'Farnham',
      postcode: 'GU9 7XG',
    },
    companyRegistrationInformation:
      'Registered in England and Wales with company number 11520330 and VAT registration number 312240070',
    ctaHeading: "Let's find your next car",
    ctaButtonText: 'Find your next car',
  },
  vehicleDetail: {
    franchiseApproved: {
      features: ['Multi-point checked', 'Approved warranty ', 'History-checked'],
      title: 'Franchise Approved Vehicle',
    },
    enquiry: {
      email: {
        saveToFavouritesBtn: 'Save vehicle to favourites',
      },
      callback: {
        saveToFavouritesBtn: 'Save vehicle to favourites',
      },
      phone: {
        saveToFavouritesBtn: 'Save to favourites',
      },
    },
    image: {
      noImages: 'No images available',
    },
    actions: {
      backToProfile: 'Back',
      backToResults: 'Back to results',
      save: 'Save as a favourite',
      unsave: 'Unsave',
      share: 'Share',
    },
    fuelEconomy: {
      header: 'Fuel Economy',
      countryDriving: {
        label: 'Country driving',
        value: 'Miles',
        unit: 'per gallon of fuel',
      },
      cityDriving: {
        label: 'City driving',
        value: 'Miles',
        unit: 'per gallon of fuel',
      },
      overall: {
        label: 'Overall',
        value: 'Miles',
        unit: 'per gallon of fuel',
      },
    },

    technicalSpecs: {
      header: 'Specs',
    },
    cta: {
      requestCallback: 'Request Callback',
      email: 'Email seller',
      call: 'Call seller',
      showMap: 'Dealer information',
      hideMap: 'Dealer information',
      distance: 'miles away',
      distanceSingular: 'mile away',
      viewDealerWebsite: 'View on the dealer’s website',
      approved: 'cinch approved dealer',
      openNow: 'Open Now - Call now',
    },
    emissions: {
      title: 'Engine and Emission',
      engineCc: 'Engine Size (cc)',
      topSpeed: 'Top Speed (mph)',
      cO2: 'CO2 Emissions (g/km)',
      standardEuroEmissions: 'Emission Standard (Euro)',
      zeroToSixty: 'Acceleration (0-62mph)',
    },
    dimensions: {
      title: 'Vehicle Dimensions',
      width: 'Width (mm)',
      height: 'Height (mm)',
      length: 'Length (mm)',
    },
    unavailable: {
      title: 'Sorry! This car is no longer available',
      subTitle: 'Don’t despair,  we’ve got loads more as good as that one',
    },
    vehicleProvenancePanel: {
      title: 'Check this vehicle’s history and get cover up to £30,000*',
      features: [
        'Fraud or theft',
        'Accident check',
        'Outstanding finance',
        'Previous owners',
        'Mileage logs',
        'Import/export history',
      ],
      ctaText: 'Order full report for £14.95',
      asteriskText: '* in case of any specified inaccuracies. ',
      readMore: 'Read more',
    },
  },
  fullPageAd: {
    holdingImageText: 'No image available',
    buyItNowText: 'Buy it now',
    unavailable: {
      title: 'Sorry! This car is no longer available',
      subTitle: 'Don’t despair, we’ve got loads more as good as that one',
    },
    vehicleSummary: {
      heading: 'Vehicle Summary',
      ulezTooltipContent:
        'The Ultra Low Emission Zone or ULEZ refers to a defined area of inner London which has tight controls on vehicle emissions. Vehicles that do not comply with the entry requirements must pay a penalty fee to enter the zone.',
    },
    vehicleInspection: {
      heading: '200+ point vehicle inspection',
      description:
        'We put every vehicle through a 200+ point inspection so that you can be confident in the quality and safety of your vehicle.',
    },
    vehicleSpecs: {
      heading: 'Vehicle specs',
    },
  },
  vehicleReviews: {
    everydayGuide: {
      tabTitle: 'Everyday guide',
      title: 'In this guide',
      tableTitle: 'Engine options',
    },
    marketReview: {
      tabTitle: 'Market review',
    },
    faultGuide: {
      tabTitle: 'Fault guide',
      whatToLook: 'What to look for:',
      whatItMeans: 'What it means:',
      whatToDo: 'What to do:',
    },
    title: 'Car Reviews',
  },
  valuationModule: {
    title: "What's my car worth?",
    body:
      'If you’re looking to sell your car faff-free, we’re here to help. Just enter your number plate below to kick things off and get a quote in no time.',
    inputLabel: 'UK Number plate',
    placeholder: 'e.g. KZ66 ZYT',
    submitLabel: 'Value my car',
  },
  paymentPage: {
    title: 'Review and Pay',
    loadingMessage: 'Loading Payment Gateway',
    errorMessage: 'Error Loading Payment Gateway',
    deliveryDetailsTitle: 'Delivery Details',
    stripePaymentForm: {
      formTitle: 'Payment',
      paymentButtonText: 'Make Payment',
      cardNumberLabel: 'Card Number',
      cardCvcLabel: 'CVC',
      cardExpiryLabel: 'Expiry Date',
      remainingAmount: 'Remaining Amount',
      providerErrorText:
        'Opps! Looks like something went wrong, our payment provider is having issues at the moment. Please try again...',
      warningTextPartOne: 'The name on your order',
      warningTextPartTwo: 'must also be the cardholders name.',
    },
  },
  checkoutDeliveryPage: {
    title: 'Delivery',
    subtitle: 'When do you want your car delivered?',
    deliverySlotPicker: {
      noAvailabilityMessage: 'There are no delivery slots available',
      showEarlierDates: 'Earlier',
      showLaterDates: 'Later',
    },
    deliveryInstructions: {
      label: 'Is there anything we need to know about your address?',
      placeholder: 'e.g. Difficult to access driveway..',
    },
    submitButton: 'Payment',
    submitError: 'An error has occurred. Please try again',
  },
  checkoutPersonalDetailsPage: {
    title: 'Enter your personal details',
    headerTitle: "Let's get started",
    headerText: 'Your next car is a few simple steps away. Lorem ipsum dolor amut!',
    personalDetailsForm: {
      firstNameInput: {
        label: 'First name',
        placeholder: "e.g. 'Robert' not 'Rob'",
      },
      lastNameInput: {
        label: 'Last name',
        placeholder: '',
      },
      emailInput: {
        label: 'Email',
        placeholder: 'e.g. robert@gmail.com',
      },
      phoneNumberInput: {
        label: 'Phone Number',
        placeholder: '',
      },
      addressLine1Input: {
        label: 'Address Line 1',
        placeholder: 'Address Line 1',
      },
      addressLine2Input: {
        label: 'Address Line 2',
        placeholder: 'Address Line 2',
      },
      addressCityInput: {
        label: 'City/Town',
        placeholder: 'City/Town',
      },
      addressCountyInput: {
        label: 'County',
        placeholder: 'County',
      },
      addressPostcodeInput: {
        label: 'Postcode',
        placeholder: 'Postcode',
      },
      addressLookupPostcode: {
        label: 'Delivery postcode',
        placeholder: 'e.g. PR15JW',
      },
      addressLookupButton: 'Find',
      addressSelectLabel: 'Select delivery address',
      addressSelectPlaceholder: 'Select address',
      enterAddressManually: 'Enter address manually',
      submitButton: 'Continue',
      submitError: 'An error has occurred. Please try again',
      nameAlert: "Your name must match the name on your driver's licence and payment account.",
      addressAlert: 'Your delivery address must match your billing address',
      preambleTitle: 'Personal details',
      preambleText: "Fill in the details below and we'll keep you up to date with your purchase.",
      formValidationError: 'Some form fields had errors. Please check your answers.',
    },
    createOrderErrors: {
      vehicleAlreadyReserved: 'Vehicle already reserved',
      vehicleNotAvailableForSale: 'Sorry this vehicle is not available for sale',
      vehicleNotFound: 'The vehicle you requested could not be found',
    },
  },
  checkoutConfirmationPage: {
    title: 'Confirmation of your order',
    returnToHomeButtonText: 'Return to homepage',
    errorRetrievingOrderMessage: 'Error occurred retrieving order details',
    youCanRelaxTitle: "You can relax, it's over to us...",
    youCanRelaxSubTitle: "We've also sent you an email with confirmation & next steps",
    whatHappensNextTitle: 'What happens next?',
    whatHappensNextBullets: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut tempus ex.',
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut tempus ex.',
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut tempus ex.',
    ],
    whatHappensNextCta: 'Find out more',
    insuranceTitle: 'Do you need FREE drive away insurance?',
    insuranceCopy: 'Quisque quis nisi tempus, fringilla dolor eget ips um dolor sit amet, consectetur',
    insuranceCtaText: 'Get free 7 day insurance',
    orderBanner: {
      title: 'Order Confirmation',
      orderNumberText: 'Order No',
      deliveryTextOne: 'Your',
      deliveryTextTwo: 'will be delivered',
    },
  },
  checkoutPartExchangePage: {
    title: 'Part-exchange your vehicle',
    addPartExchangeButton: 'Add Part-exchange to order',
    skipPartExchangeButton: 'Skip Part-exchange',
    selectVariantMessage: 'Choose the option that matches your car so we can provide an accurate valuation.',
    partExchangeAppraisalForm: {
      mileageInput: {
        label: 'Vehicle mileage',
        placeholder: 'Mileage',
      },
      registeredKeepersLabel: 'How many registered keepers has the vehicle had?',
      registeredKeepersRadioLabels: {
        One: '1',
        Two: '2',
        Three: '3',
        Four: '4',
        FivePlus: '5+',
      },
      submitButton: 'Get valuation',
      submitError: 'Something went wrong',
      vehicleConditionLabel: 'How would you describe the condition of your vehicle?',
      vehicleConditionRadioLabels: {
        Excellent: 'Excellent',
        Good: 'Good',
        Average: 'Average',
        BelowAverage: 'Below average',
        Poor: 'Poor',
      },
    },
    partExchangeVRMForm: {
      vrmInput: {
        label: 'Enter your registration number',
        placeholder: 'Vehicle reg',
      },
      submitButton: 'Find my vehicle',
      submitError: 'An error has occurred. Please try again',
    },
    yourVehicleHeading: 'Your Vehicle',
  },
  checkoutPaymentPage: {
    title: 'Pick a payment option',
    subTextWithOptions: 'Decisions, decisions - to pay monthly or in full. Its up to you.',
    payWithFinance: {
      title: 'Pay with finance',
      availability: 'Deals available from a range of lenders',
      aprText: 'APR from',
      flexiblePayments: 'Flexible payment length',
      ctaText: 'Pay monthly',
      unavailableTitle: 'Pay with finance',
      unavailableText:
        'As the balance left to pay is less than £2,000 (having taken off the part exchange price), we can’t offer you finance. Sorry about that.',
    },
    payInFull: {
      title: 'Pay in full',
      text: 'We accept all major credit and debit cards',
      ctaText: 'Pay by card',
    },
  },
  checkoutFinanceDetailsPage: {
    title: 'Quick finance checker',
    subText: 'Find out what your monthly payments could be with HP or PCP in a jiffy.',
    ctaText: 'Apply calculator to results',
    errorText: 'Unable to find suitable quotes based on your selection, please try again with alternative options.',
    depositLabel: 'Deposit amount',
    termsLabel: 'Term length',
    mileageLabel: 'Annual mileage',
    mileageInfo: '*Required for relevant PCP estimate',
    depositErrorText: 'To make sure you get an accurate quote, please make sure your deposit range is within',
    mileageOptions: [
      {
        value: '5000',
        label: '5,000 miles',
      },
      {
        value: '7500',
        label: '7,500 miles',
      },
      {
        value: '10000',
        label: '10,000 miles',
      },
      {
        value: '12500',
        label: '12,500 miles',
      },
      {
        value: '15000',
        label: '15,000 miles',
      },
      {
        value: '17500',
        label: '17,500 miles',
      },
      {
        value: '20000',
        label: '20,000 miles',
      },
      {
        value: '22500',
        label: '22,500 miles',
      },
      {
        value: '25000',
        label: '25,000 miles',
      },
      {
        value: '27500',
        label: '27,500 miles',
      },
      {
        value: '30000',
        label: '30,000 miles',
      },
    ],
    termValues: [
      { value: '24', label: '24 months' },
      { value: '36', label: '36 months' },
      { value: '48', label: '48 months' },
      { value: '60', label: '60 months' },
    ],
    briefRepresentativeExamples: {
      title: 'Representative examples preview',
      updateFilterText: 'Update filters above',
      hp: 'HP',
      pcp: 'PCP',
      notAvailable: 'Not available',
      seeMore: 'Select your option below',
    },
    representativeExamples: {
      title: 'Representative examples',
      desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed sagittis nibh',
      hpTitle: 'HP',
      hpDesc: '(Hire Purchase)',
      hpCta: 'Choose HP',
      hpModalTitle: 'HP Explained',
      aprText: 'APR',
      monthlyPaymentsOf: 'monthly payments of',
      pcpTitle: 'PCP',
      pcpDesc: '(Personal Contract Purchase)',
      pcpCta: 'Choose PCP',
      pcpUnavailableDesc:
        'Sorry, you can’t get PCP with the details you’ve given. Still prefer PCP? Please update your filters.',
      pcpUnavailableCta: 'Amend Filters',
      pcpModalTitle: 'PCP Explained',
      quote: {
        explainedText: 'explained',
        balance: 'Balance',
        totalToPay: 'Total to pay',
        deposit: 'Deposit',
        optionalFinalPayment: 'Optional final pay',
      },
    },
  },
  financePersonalDetailsPage: {
    title: 'A bit about you',
    subTitle: 'All we need from you are a few bits and bobs of info then we can move on.',
    personalDetailsLegend: 'Personal Details',
    firstNameLabel: 'First name',
    lastNameLabel: 'Surname',
    dateOfBirthLabel: 'Date of birth',
    incomeLabel: 'Income',
    formButtonText: 'Continue',
    titleLabel: 'Title',
    genderLabel: 'Gender',
    maritalStatusLabel: 'Marital Status',
    nationalityLabel: 'Nationality',
    middleNameLabel: 'Middle Name(s)',
    middleNameTip: 'If you have a middle name and it appears on your driving licence you must add it here',
    fullNameTip: 'Your name needs to match what’s on your driving licence',
    titleOptions: [
      { label: 'Dr', value: 'Dr' },
      { label: 'Miss', value: 'Miss' },
      { label: 'Ms', value: 'Ms' },
      { label: 'Mr', value: 'Mr' },
      { label: 'Mrs', value: 'Mrs' },
    ],
    genderOptions: [
      { label: 'Male', value: 'm' },
      { label: 'Female', value: 'f' },
    ],
    maritalStatusOptions: [
      { label: 'Divorced', value: 'Divorced' },
      { label: 'Married', value: 'Married' },
      { label: 'Living with Partner', value: 'Living with Partner' },
      { label: 'Single', value: 'Single' },
      { label: 'Widowed', value: 'Widowed' },
    ],
    nationalityOptions: [
      { label: 'British', value: '1' },
      { label: 'Irish', value: '5' },
      { label: 'Afghan', value: '7' },
      { label: 'Albanian', value: '8' },
      { label: 'Algerian', value: '9' },
      { label: 'American', value: '10' },
      { label: 'Andorran', value: '11' },
      { label: 'Angolan', value: '12' },
      { label: 'Argentine', value: '13' },
      { label: 'Armenian', value: '14' },
      { label: 'Aromanian', value: '15' },
      { label: 'Aruban', value: '16' },
      { label: 'Australian', value: '17' },
      { label: 'Austrian', value: '18' },
      { label: 'Azeri', value: '19' },
      { label: 'Bahamian', value: '20' },
      { label: 'Bahraini', value: '21' },
      { label: 'Bangladeshi', value: '22' },
      { label: 'Barbadian', value: '23' },
      { label: 'Belarusian', value: '24' },
      { label: 'Belgian', value: '25' },
      { label: 'Belizean', value: '26' },
      { label: 'Bermudian', value: '27' },
      { label: 'Boer', value: '28' },
      { label: 'Bosnian', value: '29' },
      { label: 'Brazilian', value: '30' },
      { label: 'Breton', value: '31' },
      { label: 'British', value: '32' },
      { label: 'British Virgin Islander', value: '33' },
      { label: 'Bulgarian', value: '34' },
      { label: 'Macedonian Bulgarian', value: '35' },
      { label: 'Burkinabe', value: '36' },
      { label: 'Burundian', value: '37' },
      { label: 'Cambodian', value: '38' },
      { label: 'Cameroonian', value: '39' },
      { label: 'Canadian', value: '40' },
      { label: 'Catalan', value: '41' },
      { label: 'Cape Verdean', value: '42' },
      { label: 'Chadian', value: '43' },
      { label: 'Chilean', value: '44' },
      { label: 'Chinese', value: '45' },
      { label: 'Comorian', value: '46' },
      { label: 'Congolese', value: '47' },
      { label: 'Croatian', value: '48' },
      { label: 'Cuban', value: '49' },
      { label: 'Cypriot', value: '50' },
      { label: 'Turkish Cypriot', value: '51' },
      { label: 'Czech', value: '52' },
      { label: 'Dane', value: '53' },
      { label: 'Dominicans (Republic)', value: '54' },
      { label: 'Dominicans (Commonwealth)', value: '55' },
      { label: 'Dutch', value: '56' },
      { label: 'East Timorese', value: '57' },
      { label: 'Ecuadorian', value: '58' },
      { label: 'Egyptian', value: '59' },
      { label: 'Emirati', value: '60' },
      { label: 'Eritrean', value: '62' },
      { label: 'Estonian', value: '63' },
      { label: 'Ethiopian', value: '64' },
      { label: 'Faroese', value: '65' },
      { label: 'Finn', value: '66' },
      { label: 'Finnish Swedish', value: '67' },
      { label: 'Fijian', value: '68' },
      { label: 'Filipino', value: '69' },
      { label: 'French citizen', value: '70' },
      { label: 'Georgian', value: '71' },
      { label: 'German', value: '72' },
      { label: 'Baltic German', value: '73' },
      { label: 'Ghanaian', value: '74' },
      { label: 'Gibraltar', value: '75' },
      { label: 'Greek', value: '76' },
      { label: 'Greek Macedonian', value: '77' },
      { label: 'Grenadian', value: '78' },
      { label: 'Guatemalan', value: '79' },
      { label: 'Guianese (French)', value: '80' },
      { label: 'Guinean', value: '81' },
      { label: 'Guinea-Bissau national', value: '82' },
      { label: 'Guyanese', value: '83' },
      { label: 'Haitian', value: '84' },
      { label: 'Honduran', value: '85' },
      { label: 'Hungarian', value: '86' },
      { label: 'Icelander', value: '87' },
      { label: 'Indian', value: '88' },
      { label: 'Indonesian', value: '89' },
      { label: 'Iranians (Persians)', value: '90' },
      { label: 'Iraqi', value: '91' },
      { label: 'Irish', value: '92' },
      { label: 'Israeli', value: '93' },
      { label: 'Italian', value: '94' },
      { label: 'Ivoirian', value: '95' },
      { label: 'Jamaican', value: '96' },
      { label: 'Japanese', value: '97' },
      { label: 'Jordanian', value: '98' },
      { label: 'Kazakh', value: '99' },
      { label: 'Kenyan', value: '100' },
      { label: 'Korean (South)', value: '101' },
      { label: 'Kosovo Albanian', value: '102' },
      { label: 'Kuwaiti', value: '103' },
      { label: 'Lao', value: '104' },
      { label: 'Latvian', value: '105' },
      { label: 'Lebanese', value: '106' },
      { label: 'Liberian', value: '107' },
      { label: 'Libyan', value: '108' },
      { label: 'Liechtensteiner', value: '109' },
      { label: 'Lithuanian', value: '110' },
      { label: 'Luxembourger', value: '111' },
      { label: 'Macedonian', value: '112' },
      { label: 'Malawian', value: '113' },
      { label: 'Maldivian', value: '114' },
      { label: 'Malian', value: '115' },
      { label: 'Maltese', value: '116' },
      { label: 'Manx', value: '117' },
      { label: 'Mauritian', value: '118' },
      { label: 'Mexican', value: '119' },
      { label: 'Moldovan', value: '120' },
      { label: 'Moroccan', value: '121' },
      { label: 'Mongolian', value: '122' },
      { label: 'Montenegrin', value: '123' },
      { label: 'Namibian', value: '124' },
      { label: 'Nepalese', value: '125' },
      { label: 'New Zealander', value: '126' },
      { label: 'Nicaraguan', value: '127' },
      { label: 'Nigerien', value: '128' },
      { label: 'Nigerian', value: '129' },
      { label: 'Norwegian', value: '130' },
      { label: 'Pakistani', value: '131' },
      { label: 'Palauan', value: '132' },
      { label: 'Palestinian', value: '133' },
      { label: 'Panamanian', value: '134' },
      { label: 'Papua New Guinean', value: '135' },
      { label: 'Paraguayan', value: '136' },
      { label: 'Peruvian', value: '137' },
      { label: 'Polish', value: '138' },
      { label: 'Portuguese', value: '139' },
      { label: 'Puerto Rican', value: '140' },
      { label: 'Quebecer', value: '141' },
      { label: 'Reunionnai', value: '142' },
      { label: 'Romanian', value: '143' },
      { label: 'Russian', value: '144' },
      { label: 'Baltic Russian', value: '145' },
      { label: 'Rwandan', value: '146' },
      { label: 'Salvadoran', value: '147' },
      { label: 'Sao Tome and Principe', value: '148' },
      { label: 'Saudi', value: '149' },
      { label: 'Senegalese', value: '151' },
      { label: 'Serb', value: '152' },
      { label: 'Sierra Leonean', value: '153' },
      { label: 'Sikh', value: '154' },
      { label: 'Singaporean', value: '155' },
      { label: 'Slovak', value: '156' },
      { label: 'Slovene', value: '157' },
      { label: 'Somali', value: '158' },
      { label: 'South African', value: '159' },
      { label: 'Spaniard', value: '160' },
      { label: 'Sri Lankan', value: '161' },
      { label: 'St Lucian', value: '162' },
      { label: 'Sudanese', value: '163' },
      { label: 'Surinamese', value: '164' },
      { label: 'Swede', value: '165' },
      { label: 'Swiss', value: '166' },
      { label: 'Syrian', value: '167' },
      { label: 'Taiwanese', value: '168' },
      { label: 'Tanzanian', value: '169' },
      { label: 'Thai', value: '170' },
      { label: 'Tibetan', value: '171' },
      { label: 'Tobagonian', value: '172' },
      { label: 'Trinidadian', value: '173' },
      { label: 'Turk', value: '174' },
      { label: 'Tuvaluan', value: '175' },
      { label: 'Ugandan', value: '176' },
      { label: 'Ukrainian', value: '177' },
      { label: 'Uruguayan', value: '178' },
      { label: 'Uzbek', value: '179' },
      { label: 'Vanuatuan', value: '180' },
      { label: 'Venezuelan', value: '181' },
      { label: 'Vietnamese', value: '182' },
      { label: 'Yemeni', value: '184' },
      { label: 'Zambian', value: '185' },
      { label: 'Zimbabwean', value: '186' },
      { label: 'Korean (North)', value: '187' },
    ],
    titlePlaceholder: 'Title',
    genderPlaceholder: 'Gender',
    middleNamePlaceholder: 'Middle name',
    dateOfBirthPlaceholder: 'DD/MM/YYYY',
    maritalStatusPlaceholder: 'Please select',
    nationalityPlaceholder: 'Please select',
    fullNameLabel: 'First name & surname',
    dateOfBirthValidationMsg: 'Invalid DOB. Please use format dd/mm/yyyy',
  },
  checkoutFinanceApplicationReview: {
    title: 'Review and submit',
    cardButtonChange: 'Change',
    btnSubmit: 'Apply',
    loanAmount: {
      partExchange: 'Part Exchange',
      vehicle: 'Vehicle',
      loanAmount: 'Loan Amount',
    },
    personalDetails: {
      title: 'Personal Details',
      forename: 'Forename',
      surname: 'Surname',
    },
    employmentStatus: {
      title: 'Employment Status',
      companyName: 'Company Name',
      years: 'Years Service',
    },
    addressHistory: {
      title: 'Address History',
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      postcode: 'Post Code',
      years: 'Years at address',
    },
  },
  checkoutFinanceBankDetails: {
    title: 'Bank account check',
    subTitle:
      'As you’re applying for finance, we need to check your identity. We do this by matching you with your bank details.',
    bankDetailsInfo:
      'cinch won’t save the bank details you give us or use them for payment. However, our lenders will use them for credit checks and for payment once your finance application’s been approved.',
    sortCodeLabel: 'Bank sort code',
    sortCodePlaceholder: '00-00-00',
    accountNumberLabel: 'Bank account number',
    accountNumberPlaceholder: '8 digits',
    accountYearsLabel: 'How may years you been with your bank?',
    accountYearsPlaceholder: 'Years',
    accountYearsTip: 'Don’t worry if you don’t know exact years, just be as accurate as you can',
    formButtonText: 'Continue',
    accountNumberValidationMsg: 'Invalid Account Number. Please use 8 digit number',
    accountYearsValidationMsg: 'Invalid Account Years. Please use a value 1 - 99',
    sortCodeValidationMsg: 'Invalid Sort Code. Please use 6 digit number',
  },
  checkoutFinanceApplicationResult: {
    title: 'Finance Application Accepted',
  },
  checkoutFinanceApplicationDecision: {
    title: 'Waiting for your decision...',
  },
  checkoutLayout: {
    header: {
      previous: 'Previous',
      label: 'Step {current} of {max}',
      allSteps: 'All steps',
    },
    orderDetails: {
      banner: {
        orderDetailsLabel: {
          closed: 'Order summary',
          open: 'Close',
        },
      },
      panel: {
        loadError: 'Something went wrong. Please reload the page',
        partExchangeLabel: 'Part exchange',
        toPaySummary: {
          monthsLabel: '{months} months',
          payMonthlyLabel: 'To pay monthly',
          payTodayLabel: 'To pay today',
          perMonthLabel: 'per month',
          title: 'What will I pay?',
          totalLabel: 'Total',
        },
        totalToPayLabel: 'Total to Pay',
        vehicleTotalLabel: 'Vehicle total',
      },
      loadError: 'Something went wrong. Please reload the page',
    },
    stepDrawer: {
      header: 'Checkout Steps',
      bannerText: "You're only {stepsRemaining} steps away from owning your next car.",
      steps: {
        personalDetails: 'Personal details',
        partExchange: 'Want to part exchange?',
        deliverySlots: 'Delivery',
        finance: 'Cash or finance?',
        payment: 'Payment Details',
        orderSummary: 'Order Summary',
        timeEstimateSingle: 'Should take around {value} minute',
        timeEstimateMultiple: 'Should take around {value} minutes',
      },
    },
  },
  checkoutFinanceCurrentAddressPage: {
    title: "Where you've lived",
    subText: 'Please tell us the address(es) you’ve lived at over the past three years. We need a maximum of 3.',
    currentAddressTitle: 'Current address',
    previousAddressTitle: 'Previous address',
    currentAddressInfo: 'Current address must be the same as delivery address for purposes of the finance application',
    propertyLegend: 'Time at property',
    monthsPlaceholder: '0 months',
    yearsPlaceholder: '0 years',
    addAddressBtn: 'Add this address',
    removeAddressBtn: 'Remove Address',
    addPreviousAddressText: 'Add previous home address',
    submitBtn: 'Continue',
    errorMessage: 'Please make sure your addresses add up to 3 years.',
  },
  checkoutFinanceOutgoings: {
    title: 'About repayments',
    subText:
      'To put your mind at rest (and ours), you need to be sure you can cover monthly repayments now and in the future.',
    mortgageRentContributionLabel: 'Monthly mortgage / rent',
    otherOutgoings: 'Additional outgoings',
    submitBtn: 'Continue',
    grossAnnualIncome: 'Gross Annual Income',
    placeholder: '£ (Pounds Sterling)',
    affordabilityLabel:
      'Do you expect any changes in circumstances that would affect the affordability of this loan? E.g Maternity leave, redundancy risk etc',
    affordabilityReasonLabel: 'Please give us further details',
    grossAnnualIncomeWarningText:
      'A customer who earns less than £8749 a year have a higher risk of declined applications. Are you sure you wish to continue?',
  },
  checkoutFinanceEmploymentHistory: {
    title: 'Where you’ve worked',
    subText:
      'Been at your current company for less than 3 years? No problem. Just tell us where you worked before too.',
    fields: {
      previousEmploymentWarning: 'As you worked there for less than 3 years we need one more',
      addPreviousRoleText: 'Add previous role',
      formTitle: 'Current / most recent employer',
      addEmployerCta: 'Add this employer',
      employmentStatus: {
        label: 'Employment Status',
        options: [
          {
            label: 'Employed',
            value: 'employed',
          },
          {
            label: 'Self Employed',
            value: 'selfEmployed',
          },
          {
            label: 'Non Working',
            value: 'nonWorking',
          },
          {
            label: 'Retired',
            value: 'retired',
          },
        ],
      },
      genericSelectPlaceholder: 'Please Select',
      occupationType: {
        label: 'Occupation Type',
        options: [
          { label: 'Accountancy', value: 'Accountancy' },
          { label: 'Armed Forces', value: 'Armed Forces' },
          { label: 'Artists', value: 'Artists' },
          { label: 'Benefits', value: 'Benefits' },
          { label: 'Civil Service', value: 'Civil Service' },
          { label: 'Clergy/Religious Worker', value: 'Clergy/Religious Worker' },
          { label: 'Clerical/Admin Support', value: 'Clerical/Admin Support' },
          { label: 'Computers/IT', value: 'Computers/IT' },
          { label: 'Construction', value: 'Construction' },
          { label: 'Consultants', value: 'Consultants' },
          { label: 'Counsellors', value: 'Counsellors' },
          { label: 'Directors', value: 'Directors' },
          { label: 'Drivers (not taxi drivers)', value: 'Drivers (not taxi drivers)' },
          { label: 'Engineers', value: 'Engineers' },
          { label: 'Factory', value: 'Factory' },
          { label: 'Farmers', value: 'Farmers' },
          { label: 'Finance/Banking', value: 'Finance/Banking' },
          { label: 'Food Preparation/Service', value: 'Food Preparation/Service' },
          { label: 'Health Occupations', value: 'Health Occupations' },
          { label: 'Housewife / House Husband', value: 'Housewife / House Husband' },
          { label: 'Insurance', value: 'Insurance' },
          { label: 'Lawyers/Judges', value: 'Lawyers/Judges' },
          { label: 'Librarians', value: 'Librarians' },
          { label: 'Management', value: 'Management' },
          { label: 'Mechanics and repairers', value: 'Mechanics and repairers' },
          { label: 'Military Officer', value: 'Military Officer' },
          { label: 'Police', value: 'Police' },
          { label: 'Precision/production Occ.', value: 'Precision/production Occ.' },
          { label: 'Professional Sports', value: 'Professional Sports' },
          { label: 'Retail', value: 'Retail' },
          { label: 'Retired', value: 'Retired' },
          { label: 'Sales Rep/Act Mgmnt', value: 'Sales Rep/Act Mgmnt' },
          { label: 'Scientist/Researcher', value: 'Scientist/Researcher' },
          { label: 'Security Occupations', value: 'Security Occupations' },
          { label: 'Service Occupations', value: 'Service Occupations' },
          { label: 'Student', value: 'Student' },
          { label: 'Taxi Driver Black Cab', value: 'Taxi Driver Black Cab' },
          { label: 'Taxi Driver Non Black Cab', value: 'Taxi Driver Non Black Cab' },
          { label: 'Teachers/Professors', value: 'Teachers/Professors' },
          { label: 'Team Leader', value: 'Team Leader' },
          { label: 'Telesales', value: 'Telesales' },
          { label: 'Temporary', value: 'Temporary' },
          { label: 'Driving Instructor', value: 'Driving Instructor' },
          { label: 'Foster Carer', value: 'Foster Carer' },
        ],
      },
      jobTitle: {
        label: 'Job Title',
        placeholder: 'Job Title',
      },
      employmentType: {
        label: 'Permanent / temporary',
        options: [
          {
            label: 'Permanent',
            value: 'Permanent',
          },
          {
            label: 'Temporary',
            value: 'Temporary',
          },
        ],
      },
      employerName: {
        label: 'Employer name',
        placeholder: 'Employer name',
      },
      postcode: {
        label: 'Postcode',
        placeholder: 'Postcode',
      },
      city: {
        label: 'City',
        placeholder: 'City',
      },
      employmentPeriod: {
        label: 'Employment Period',
        years: {
          label: 'Years',
          placeholder: 'Years',
        },
        months: {
          label: 'Months',
          placeholder: 'Months',
        },
      },
    },
  },
  addressFields: {
    buildingNumber: 'Building Number',
    addressLineOne: 'Address Line One',
    addressLineTwo: 'Address Line Two',
    addressLineThree: 'Address Line Three',
    city: 'City',
    county: 'County',
    postcode: 'Postcode',
    addressLookup: {
      label: 'Postcode Lookup',
      placeholder: '',
    },
    addressLookupButton: 'Find address',
    addressSelectPlaceholder: 'Select address',
    addressSelectLabel: 'Select delivery address',
    enterAddressManually: 'Enter address manually',
  },
  orderBreakdown: {
    title: 'Order Breakdown',
    payInFullTitle: 'To pay today',
  },
  postcodeValidationErrors: {
    invalid: 'It looks like that postcode is invalid. Please try again',
    cannotDeliver: "It looks like we can't deliver to that postcode. Please try a different address",
    default: 'An error has occurred. Please try again',
  },
}

export default data
